import { Dialog, DialogTrigger, DialogContent, DialogTitle, DialogDescription, DialogClose, DialogFooter } from "@/components/ui/dialog";
import { useState } from "react";
import { Label } from "@/components/atoms/texts/label";
import { Button } from "@/components/molecules/buttons/button";

export default function EditAdminModal({ data, onClose, type, form, onSubmitForm, title, disabledSubmit = false , mediumSize = false}) {
    const [formData, setFormData] = useState(data);

    // const handleChange = (e) => {
    //     const { name, value } = e.target;
    //     setFormData({ ...formData, [name]: value });
    // };

    const defaultSubmit = () => {
        // Logique pour soumettre les modifications
        console.log("No functions linked with this button. formData is ", formData);
        onClose();
    };

    const getTitle = () => {
        switch (type) {
            case 'expense':
                return 'consultants.editModal.editExpense';
            case 'companyBenefit':
                return 'consultants.editModal.editCompanyBenefit';
            case 'payslip':
                return 'consultants.editModal.editPayslip';
            case 'timesheet':
                return 'consultants.editModal.editTimesheet';
            default:
                return 'global.actions.edit';
        }
    };

    return (
        <Dialog open onOpenChange={onClose} >
            <DialogContent className={`${mediumSize ? 'max-w-[700px]' : 'max-w-[1200px]'} bg-medium`}>
                <DialogTitle>
                    <Label fontWeight="bold" size="h4" message={title || getTitle()}>{title || getTitle()}</Label>
                </DialogTitle>

                <DialogDescription className={"max-h-[70vh] bg-lighter rounded-sm"}>
                    {form}
                </DialogDescription>
                <DialogFooter>
                    <DialogClose  >
                        <Button text="global.actions.close" style="ghost" onClick={onClose} />
                    </DialogClose>
                    <Button className="w-full" text="global.actions.save" onClick={onSubmitForm || defaultSubmit} disabled={disabledSubmit}></Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
